module.exports = __webpack_public_path__ + "static/media/close_icon.b1f4b8be.svg";